import { render, staticRenderFns } from "./ModalReferralPartnerNew.vue?vue&type=template&id=30abaeaf&"
import script from "./ModalReferralPartnerNew.vue?vue&type=script&lang=js&"
export * from "./ModalReferralPartnerNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports